export default __webpack_public_path__ + "static/media/Madan-Mahal-Fort.d6d3b0b1.jpg";